import { useTranslation } from "react-i18next";
import DigitalServicesHero from "../digitalServicesHero";
import SolutionsView from "../solutionsView";
import TechStackList from "../techStackList";
import projectsData from '../../../assets/data/projects.json';
import { Box, Stack } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import ButtonComponent from '../../../components/form/buttonComponent';
import ProjectDetails from "../projectDetails";
import GetQuote from "../../contactUs/getQuote";
import companyData from '../../../assets/data/company.json';

const key = "services.digital.web";

const techStackList = [
    { src: "/images/tech-stack/ReactJS.png", alt: "ReactJS" },
    { src: "/images/tech-stack/Angular.png", alt: "Angular" },
    { src: "/images/tech-stack/VueJS.png", alt: "VueJS" },
    { src: "/images/tech-stack/Next.js.png", alt: "NextJS" },
    { src: "/images/tech-stack/NuxtJS.png", alt: "NuxtJS" },
    { src: "/images/tech-stack/Bootstrap.png", alt: "Bootstrap" },
    { src: "/images/tech-stack/MaterialUI.png", alt: "Material UI" },
    { src: "/images/tech-stack/NodeJS.png", alt: "NodeJS" },
    { src: "/images/tech-stack/SpringBoot.png", alt: "Spring Boot" },
    { src: "/images/tech-stack/Django.png", alt: "Django" },
    { src: "/images/tech-stack/RubyRails.png", alt: "Ruby on Rails" },
    { src: "/images/tech-stack/Laravel.png", alt: "Laravel" },
    { src: "/images/tech-stack/ASPNETCore.png", alt: "ASP.NET Core" },
    { src: "/images/tech-stack/JavaScript.png", alt: "JavaScript" },
    { src: "/images/tech-stack/TypeScript.png", alt: "TypeScript" },
    { src: "/images/tech-stack/Python.png", alt: "Python" },
    { src: "/images/tech-stack/Java.png", alt: "Java" },
    { src: "/images/tech-stack/PHP.png", alt: "PHP" },
    { src: "/images/tech-stack/Go.png", alt: "Go" },
    { src: "/images/tech-stack/MySQL.png", alt: "MySQL" },
    { src: "/images/tech-stack/PostgreSQL.png", alt: "PostgreSQL" },
    { src: "/images/tech-stack/MongoDB.png", alt: "MongoDB" },
    { src: "/images/tech-stack/Firebase.png", alt: "Firebase" },
    { src: "/images/tech-stack/RESTAPIs.png", alt: "REST APIs" },
    { src: "/images/tech-stack/WebSockets.png", alt: "WebSockets" },
    { src: "/images/tech-stack/Docker.png", alt: "Docker" },
    { src: "/images/tech-stack/Kubernetes.png", alt: "Kubernetes" },
    { src: "/images/tech-stack/Jenkins.png", alt: "Jenkins" },
    { src: "/images/tech-stack/Selenium.png", alt: "Selenium" },
    { src: "/images/tech-stack/Postman.png", alt: "Postman" },
    { src: "/images/tech-stack/WordPress.png", alt: "WordPress" },
    { src: "/images/tech-stack/Git.png", alt: "Git" }
];

const WebSolutionsLayout = () => {
    const {t} = useTranslation();

    const solutionsList = [
        {title: t(`${key}.categories.1.label`), description: t(`${key}.categories.1.description`), icon: '/images/icons/enterprise.svg'},
        {title: t(`${key}.categories.2.label`), description: t(`${key}.categories.2.description`), icon: '/images/icons/prototype.svg'},
        {title: t(`${key}.categories.3.label`), description: t(`${key}.categories.3.description`), icon: '/images/icons/shopping-cart.svg'},
        {title: t(`${key}.categories.4.label`), description: t(`${key}.categories.4.description`), icon: '/images/icons/cms.svg'},
        {title: t(`${key}.categories.5.label`), description: t(`${key}.categories.5.description`), icon: '/images/icons/cross-platform.svg'},
        {title: t(`${key}.categories.6.label`), description: t(`${key}.categories.6.description`), icon: '/images/icons/pwa.svg'},
        {title: t(`${key}.categories.7.label`), description: t(`${key}.categories.7.description`), icon: '/images/icons/api.svg'},
        {title: t(`${key}.categories.8.label`), description: t(`${key}.categories.8.description`), icon: '/images/icons/setting.svg'}
    ];

    const [getQuote, setGetQuote] = useState(false);

    const getAQuote = useCallback(() => {
        // setGetQuote(true);

        window.open(companyData.contact.formLinks.quotation, "_blank");
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <DigitalServicesHero 
                banner="/images/services/digital/web/webBanner.png"
                title={t(`${key}.label`)}
                description={t(`${key}.description`)}
            />

            <SolutionsView list={solutionsList}/>

            <TechStackList list={techStackList}/>

            <ProjectDetails 
                list={projectsData.web}
                px="7.5%"
            />

            <Stack
                direction='row'
                justifyContent='center'
                alignItems='center'
                width='100%'
                pb={{xs: 2, md: 0}}
            >
                <ButtonComponent 
                    label={t('services.interested')}
                    onClick={getAQuote}
                    sx={{
                        animation: 'bounceButton 1s infinite'
                    }}
                />
            </Stack>

            <GetQuote open={getQuote} setOpen={setGetQuote}/>
        </>
    );
}

export default WebSolutionsLayout;